{
    "tt": {
        "Yes": "Әйе",
        "No": "Юк",
        "Cancel": "Баш тарту",
        "Close": "Ябу",
        "Clear": "Чистарту",
        "Done": "Әзер",
        "Loading": "Йөкләнә...",
        "Select": "Сайлау...",
        "Search": "Эзләү",
        "Back": "Артка",
        "OK": "OK",
        "dxCollectionWidget-noDataText": "Мәгълүмат юк",
        "dxList-pullingDownText": "Яңарту өчен түбән тартыгыз...",
        "dxList-pulledDownText": "Яңарту өчен җибәрегез...",
        "dxList-refreshingText": "Яңартыла...",
        "dxList-pageLoadingText": "Йөкләнә...",
        "dxList-nextButtonText": "Күбрәк",
        "dxList-selectAll": "Барысын да сайлау",
        "dxDataGrid-noDataText": "Мәгълүмат юк"
    }
}
